export const ADD_COUNTRIES = 'ADD_COUNTRIES';
export const ADD_TIMEZONES = 'ADD_TIMEZONES';
export const ADD_LANGUAGES = 'ADD_LANGUAGES';
export const SET_IS_NANO = 'SET_IS_NANO';
export const SET_HAS_SETUP = 'SET_HAS_SETUP';
export const ENQUEUE_SNACKBAR = 'ENQUEUE_SNACKBAR';
export const REMOVE_SNACKBAR = 'REMOVE_SNACKBAR';
